/* Removes the four-tile badge row on the PDP — Super Fast Shipping,
   Hassle-Free Returns, Concierge Support, 1-Year Warranty.

   It is made redundant by the highlights panel under Add to cart, which now
   covers shipping, returns and the warranty in the shopper's own terms.

   WHY SCRIPT AND NOT CSS. The tiles are template blocks in
   templates/product.json — 75KB, past the size the Admin API can rewrite — so
   they cannot be deleted from here. CSS cannot do it safely either: the only
   stable hooks are the generated per-block classes on each tile, and
   .group-block:has(.text-block--<id>) matches EVERY ancestor group-block, not
   the nearest one. The outermost of those wraps the entire product column, so
   that rule would blank the page. Resolving the nearest common ancestor is the
   part only script can do.

   THE DURABLE FIX is to delete or hide these blocks in the theme editor, where
   they live. This is a preview-side removal so the layout can be judged first.

   The four hooks below are block ids from product.json. If a tile is edited or
   replaced its id changes, one lookup returns nothing, and this does nothing at
   all rather than guessing at a different element. */
(function () {
  'use strict';

  var HOOKS = [
    '.text-block--AM21DSVpTMllvOXIzL__text_Hq4iGT',
    '.text-block--AdkNlbFRvS0F2UDNzN__text_DRMYrh',
    '.text-block--AdkkxU0s3K3BHNnpPV__text_fN97nd',
    '.text-block--AOXNrYzlkeXJpVS9hZ__text_UmcfKJ'
  ];

  function hide() {
    var main = document.getElementById('MainContent');
    if (!main) return;

    var tiles = [];
    for (var i = 0; i < HOOKS.length; i++) {
      var el = main.querySelector(HOOKS[i]);
      if (!el) return; /* a tile was edited or removed - leave the page alone */
      tiles.push(el);
    }

    /* Nearest ancestor holding all four. */
    var node = tiles[0];
    while (node && node !== main) {
      var all = true;
      for (var j = 1; j < tiles.length; j++) {
        if (!node.contains(tiles[j])) { all = false; break; }
      }
      if (all) break;
      node = node.parentElement;
    }
    if (!node || node === main) return;

    var wrap = node.closest('.group-block') || node;

    /* Guards. If the resolved element has swallowed the buy controls or the
       description, the structure is not what this was written against and
       hiding it would take half the page with it. */
    if (wrap.querySelector('product-form-component')) return;
    if (wrap.querySelector('.suti-buy')) return;
    if (wrap === main || wrap.contains(main)) return;

    if (wrap.dataset.sutiHidden === '1') return;
    wrap.dataset.sutiHidden = '1';
    wrap.style.setProperty('display', 'none', 'important');
  }

  hide();

  /* The theme morphs this markup back in on variant change. Coalesced to one
     pass per frame - see the note in suti-buyblock.js about what an
     uncoalesced observer costs on this page. */
  var queued = false;
  new MutationObserver(function () {
    if (queued) return;
    queued = true;
    requestAnimationFrame(function () {
      queued = false;
      hide();
    });
  }).observe(document.documentElement, { childList: true, subtree: true });
})();
